var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SendProductOfferModal", {
    attrs: { name: "send-productOffer" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ open }) {
          return [
            _c(
              "a",
              {
                staticClass:
                  "btn btn--outline btn--outline-dark w-100 text-shade-dark-hover",
                attrs: {
                  disabled:
                    _vm.configInvalid ||
                    Object.keys(_vm.configInvalid).length > 0,
                },
                on: { click: open },
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "svg-icon icon-mail mr-2",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 19.95 14.51",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M0 3.08v9.8l5.99-4.9L0 3.08z" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M18.32 0H1.64A1.76 1.76 0 00-.02 1.26l7.8 6.53 1.27 1.09a1.34 1.34 0 001.64 0l1.45-1.09 7.84-6.33A1.74 1.74 0 0018.32 0z",
                        fill: "#3a3a39",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: { d: "M19.95 12.88v-9.8l-5.98 4.9 5.98 4.9z" },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M11.79 9.8l-1.08.91a1.37 1.37 0 01-1.64 0L7.62 9.62l-.72-.73-6.35 5.26a2.57 2.57 0 001.09.37h16.68a1.39 1.39 0 00.91-.37l-6.35-5.26z",
                        fill: "#3a3a39",
                      },
                    }),
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("translate")("txtSendOffer")) +
                    "\n        "
                ),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }